import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';



const query= new QueryClient()
ReactDOM.render(
  <React.StrictMode>
      <Provider store={store}>
        <Router>
        <QueryClientProvider client={query}>
        <App />
        </QueryClientProvider>
        </Router>
      </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);